//@ts-check

if (!customElements.get("ff-variants-quantity-input")) {
  class FfVariantsQuantityInput extends HTMLElement {
    constructor() {
      super();

      if (!this.dataset.hasOwnProperty("ffDisabled")) {
        /**
         * @type {NodeListOf<HTMLElement>}
         */
        this.ffVariantsBtn = (() => {
          /**
           * @type {NodeListOf<HTMLElement>}
           */
          const ffVariantsBtn = document.querySelectorAll(
            `[data-ff-variants-quantity-input-id='${this.id}']`
          );

          if (ffVariantsBtn.length > 0) {
            return ffVariantsBtn;
          } else {
            throw new Error("Missing variants buttons");
          }
        })();

        /**
         * @type {HTMLInputElement}
         */
        this.ffInput = (() => {
          const ffInput = this.querySelector("input");

          if (ffInput) {
            return ffInput;
          } else {
            throw new Error("Missing variants buttons");
          }
        })();

        this.ffInput.value = "1"; // Añadido por itS

        this.ffVariantsBtn.forEach((ffVariantBtn) => {
          ffVariantBtn.addEventListener("click", () =>
            this.ffInitVariant(ffVariantBtn)
          );
        });

        if (this.dataset.hasOwnProperty("ffNoInitBtn")) {
          this.ffInput.addEventListener(
            "change",
            this.ffOnInputChange.bind(this)
          );
          this.querySelectorAll("[data-ff-variants-quantity-input-button]").forEach((button) =>
            button.addEventListener("click", this.ffOnButtonClick.bind(this))
          );
        } else {
          /**
           * @type {HTMLElement}
           */
          this.ffInitBtn = (() => {
            /**
             * @type {HTMLElement | null}
             */
            const ffInitBtn = this.querySelector(
              "[data-ff-variants-quantity-input-init-btn]"
            );

            if (ffInitBtn) {
              return ffInitBtn;
            } else {
              throw new Error("Missing init button");
            }
          })();

          this.ffInitBtn.addEventListener("click", () => this.ffInitInput(), {
            once: true,
          });
        }
      }
    }

    ffInitInput() {
      if (!this.ffVariantSelected) {
        this.ffVariantsBtn[0].click();
      }

      this.ffInput.addEventListener("input", this.ffOnInputChange.bind(this));
      this.querySelectorAll("[data-ff-variants-quantity-input-button]").forEach((button) =>
        button.addEventListener("click", this.ffOnButtonClick.bind(this))
      );
    }

    /**
     *
     * @param {HTMLElement} variantBtn
     */
    ffInitVariant(variantBtn) {
      this.ffVariantSelected = variantBtn;

      const { ffVariantBulkAddQuantity, ffVariantFormId } = variantBtn.dataset;
      this.ffInput.value = ffVariantBulkAddQuantity || "1";
      this.ffInput.setAttribute("form", ffVariantFormId || "");
    }

    ffOnInputChange(e) {
      if (!this.ffVariantSelected) {
        e.preventDefault();
        this.ffInput.value = "";
      } else {
        this.validateQtyRules();
      }
    }

    ffOnButtonClick(event) {
      event.preventDefault();
      
      if (this.ffVariantSelected) {
        
        const previousValue = this.ffInput.value;

        if (event.target.dataset.ffName === "plus") {
          if (
            this.ffInput.dataset.min &&
            parseInt(this.ffInput.dataset.min) > parseInt(this.ffInput.step) &&
            this.ffInput.value == "0"
          ) {
            this.ffInput.value = this.ffInput.dataset.min;
          } else {
            this.ffInput.stepUp();
          }
        } else {
          this.ffInput.stepDown();
        }

        if (
          this.ffInput.dataset.min === previousValue &&
          event.target.dataset.ffName === "minus"
        ) {
          this.ffInput.value = this.ffInput.min;
        }

        if (this.ffVariantSelected) {
          this.ffVariantSelected.dataset.ffVariantBulkAddQuantity =
            this.ffInput.value;
        }
      }
    }

    validateQtyRules() {
      const value = parseInt(this.ffInput.value);

      if (this.ffInput.min) {
        const buttonMinus = this.querySelector("[data-ff-name='minus']");
        if (buttonMinus) {
          buttonMinus.classList.toggle(
            "disabled",
            value <= parseInt(this.ffInput.min)
          );
        }
      }

      if (this.ffInput.max) {
        const max = parseInt(this.ffInput.max);
        const buttonPlus = this.querySelector("[data-ff-name='plus]'");
        if (buttonPlus) {
          buttonPlus.classList.toggle("disabled", value >= max);
        }
      }

      if (this.ffVariantSelected) {
        this.ffVariantSelected.dataset.ffVariantBulkAddQuantity =
          this.ffInput.value;
      }
    }
  }

  customElements.define("ff-variants-quantity-input", FfVariantsQuantityInput);
}
